import { Injectable, Inject } from '@angular/core';
import { GridDataService } from './core/griddata.service';
import { ProduktTypService } from '../odata-services';
import { NotificationService } from '@progress/kendo-angular-notification';

@Injectable({
  providedIn: 'root'
})
export class ProduktTypDataService extends GridDataService {
    
  public odataService: ProduktTypService;
  
  
    constructor(  @Inject(ProduktTypService)  service: ProduktTypService, @Inject(NotificationService) notificationService?: NotificationService) { 
      super(service,null,notificationService); 
      this.odataService = service;
    }

}
